/// <reference no-default-lib="true"/>

import { Link } from "react-router-dom";

/* eslint-disable */
export default function Email({ email }) {
    return (<Link to={'mailto:' + email}><strong>E-mail: </strong> {' ' + email}</Link>)
}